
<div class="login-con">
  <div class="login-content">
    <mat-card style="margin-top: -70px;">
        <mat-card-title>
              <h6>Change Password</h6>
        </mat-card-title>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <mat-form-field class="full-width-input">
                <input matInput type="password" placeholder="Existing Password" [(ngModel)]="password" formControlName="password" required />
                <mat-error *ngIf="isFieldInvalid('password')">
                  Please inform your Current Password
                </mat-error>
              </mat-form-field>

              <mat-form-field class="full-width-input mt-3">
                <input matInput [type]="hide ? 'password' : 'text'" placeholder="New Password " [(ngModel)]="newPassword"  formControlName="newPassword" required (keyup)="checkStrength($event)" />
                <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                <mat-error *ngIf="form.controls['newPassword'].hasError('required')">
                  New password is <strong>required</strong>
                </mat-error>
                <mat-hint *ngIf="showStrength" style="font-size: 14px;">
                  <strong>Strength : </strong><span [ngStyle]="{'color': color}"><strong>{{passwordStrength}}</strong></span>
                </mat-hint>
              </mat-form-field>
              <mat-form-field class="full-width-input mt-3">
                <input matInput type="password" placeholder="Confirm New Password" formControlName="newPasswordAgain" required (keyup)="checkPassword($event)" />
                <mat-error *ngIf="isFieldInvalid('newPasswordAgain')">
                  Please inform new password
                </mat-error>
              </mat-form-field>
              <div *ngIf="(form.controls['newPasswordAgain'].touched || form.controls['newPasswordAgain'].dirty) && !samePwd" style="color:red;font-size: 9px;">
                Password and Confirm Password don’t match
              </div>
              <div class="passTip mt-4">
                <strong>Password must contain:</strong>
                <ul class="passwordr">
                  <li><img src="../../../../assets/icons/check.png" class="img-fluid tickcheck">atleast 1 capital letter</li>

                  <li><img src="../../../../assets/icons/check.png" class="img-fluid tickcheck">atleast 1 small letter</li>
                  <li><img src="../../../../assets/icons/check.png" class="img-fluid tickcheck">atleast 1 number</li>
                  <li><img src="../../../../assets/icons/check.png" class="img-fluid tickcheck">atleast 1 special character</li>
                  <li><img src="../../../../assets/icons/check.png" class="img-fluid tickcheck">minimum 8 characters</li>
                </ul>
              </div>
              <!-- passwordStrength.toLowerCase() !== 'strong' -->
              <button mat-raised-button color="primary" [disabled]="!samePwd || form.invalid">Submit</button>
            </form>
          </mat-card-content>
    </mat-card>
  </div>
</div>
  